import Vue from "vue";
import Router from "vue-router";
import AuthLayout from "../components/auth/AuthLayout";
import AppLayout from "../components/admin/AppLayout";

Vue.use(Router);

const EmptyParentComponent = {
  template: "<router-view></router-view>",
};

const demoRoutes = [];

export default new Router({
  mode: process.env.VUE_APP_ROUTER_MODE_HISTORY === "true" ? "history" : "hash",
  routes: [
    ...demoRoutes,
    {
      path: "*",
      redirect: { name: "dashboard" },
    },
    {
      path: "/auth",
      component: AuthLayout,
      children: [
        {
          name: "login",
          path: "login",
          component: () => import("../components/auth/login/Login.vue"),
        },
        {
          path: "",
          redirect: { name: "login" },
        },
      ],
    },
    {
      name: "Admin",
      path: "/admin",
      component: AppLayout,
      children: [
        {
          name: "dashboard",
          path: "dashboard",
          component: () => import("../components/dashboard/Dashboard.vue"),
          default: true,
        },
        {
          name: "teachers",
          path: "teachers",
          component: EmptyParentComponent,
          children: [
            {
              name: "saveTeacher",
              path: "saveTeacher",
              component: () => import("../components/teachers/saveTeacher"),
            },
            {
              name: "updateTeacher",
              path: "updateTeacher/:id",
              component: () => import("../components/teachers/saveTeacher"),
            },
            {
              name: "listTeacher",
              path: "listTeacher",
              component: () => import("../components/teachers/teachers"),
            },
            {
              name: "teacherFrom",
              path: "teacherFrom",
              component: () => import("../components/teachers/teacherFrom"),
            },
          ],
        },
        {
          name: "students",
          path: "students",
          component: EmptyParentComponent,
          children: [
            {
              name: "saveStudent",
              path: "saveStudent",
              component: () => import("../components/student/saveStudent"),
            },
            {
              name: "updateStudent",
              path: "updateStudent/:id",
              component: () => import("../components/student/saveStudent"),
            },
            {
              name: "listStudent",
              path: "listStudent",
              component: () => import("../components/student/student"),
            },
            {
              name: "saveStudentOffer",
              path: "saveStudentOffer",
              component: () => import("../components/student/saveStudentOffer"),
            },
            {
              name: "updateStudentOffer",
              path: "updateStudentOffer/:id",
              component: () => import("../components/student/saveStudentOffer"),
            },
            {
              name: "studentOffer",
              path: "studentOffer",
              component: () => import("../components/student/studentOffer"),
            },
            {
              name: "listOfferManage",
              path: "listOfferManage",
              component: () => import("../components/student/offerManage"),
            },
            {
              name: "saveOfferManage",
              path: "saveOfferManage",
              component: () => import("../components/student/saveOfferManage"),
            },
            {
              name: "updateOfferManage",
              path: "updateOfferManage/:id",
              component: () => import("../components/student/saveOfferManage"),
            },
          ],
        },
        {
          name: "services",
          path: "services",
          component: EmptyParentComponent,
          children: [
            {
              name: "saveService",
              path: "saveService",
              component: () => import("../components/services/saveService"),
            },
            {
              name: "updateService",
              path: "updateService/:id",
              component: () => import("../components/services/saveService"),
            },
            {
              name: "listService",
              path: "listService",
              component: () => import("../components/services/listService"),
            },
            {
              name: "onlineAction",
              path: "onlineAction",
              component: () => import("../components/services/onlineAction"),
            },
            {
              name: "saveOnlineAction",
              path: "saveOnlineAction",
              component: () =>
                import("../components/services/saveOnlineAction"),
            },
            {
              name: "updateOnlineAction",
              path: "updateOnlineAction/:id",
              component: () =>
                import("../components/services/saveOnlineAction"),
            },
            {
              name: "enterpriseToOne",
              path: "enterpriseToOne",
              component: () => import("../components/services/enterpriseToOne"),
            },
            {
              name: "saveEnterpriseToOne",
              path: "saveEnterpriseToOne",
              component: () =>
                import("../components/services/saveEnterpriseToOne"),
            },
            {
              name: "updateEnterpriseToOne",
              path: "updateEnterpriseToOne/:id",
              component: () =>
                import("../components/services/saveEnterpriseToOne"),
            },
            {
              name: "enterprisePracticeResource",
              path: "enterprisePracticeResource",
              component: () =>
                import("../components/services/enterprisePracticeResource"),
            },
            {
              name: "saveEnterprisePracticeResource",
              path: "saveEnterprisePracticeResource",
              component: () =>
                import("../components/services/saveEnterprisePracticeResource"),
            },
            {
              name: "updateEnterprisePracticeResource",
              path: "updateEnterprisePracticeResource/:id",
              component: () =>
                import("../components/services/saveEnterprisePracticeResource"),
            },
          ],
        },
        {
          name: "news",
          path: "news",
          component: EmptyParentComponent,
          children: [
            {
              name: "saveNews",
              path: "saveNews",
              component: () => import("../components/news/saveNews"),
            },
            {
              name: "updateNews",
              path: "updateNews/:id",
              component: () => import("../components/news/saveNews"),
            },
            {
              name: "listNews",
              path: "listNews",
              component: () => import("../components/news/news"),
            },
          ],
        },
        {
          name: "problem",
          path: "problem",
          component: EmptyParentComponent,
          children: [
            {
              name: "listFeedback",
              path: "listFeedback",
              component: () => import("../components/problem/feedbacks"),
            },
            {
              name: "saveFeedback",
              path: "saveFeedback",
              component: () => import("../components/problem/saveFeedback"),
            },
            {
              name: "updateFeedback",
              path: "updateFeedback/:id",
              component: () => import("../components/problem/saveFeedback"),
            },
            {
              name: "listCommonQuestion",
              path: "listCommonQuestion",
              component: () => import("../components/problem/commonQuestion"),
            },
            {
              name: "saveCommonQuestion",
              path: "saveCommonQuestion",
              component: () =>
                import("../components/problem/saveCommonQuestion"),
            },
            {
              name: "updateCommonQuestion",
              path: "updateCommonQuestion/:id",
              component: () =>
                import("../components/problem/saveCommonQuestion"),
            },
          ],
        },
        {
          name: "tags",
          path: "tags",
          component: EmptyParentComponent,
          children: [
            {
              name: "listPositionTag",
              path: "listPositionTag",
              component: () => import("../components/tags/listPositionTag"),
            },
            {
              name: "savePositionTag",
              path: "savePositionTag",
              component: () => import("../components/tags/savePositionTag"),
            },
            {
              name: "updatePositionTag",
              path: "updatePositionTag/:id",
              component: () => import("../components/tags/savePositionTag"),
            },
            {
              name: "listQuestionTag",
              path: ":positionTagId/listQuestionTag",
              component: () => import("../components/tags/listQuestionTag"),
            },
            {
              name: "saveQuestionTag",
              path: ":positionTagId/saveQuestionTag",
              component: () => import("../components/tags/saveQuestionTag"),
            },
            {
              name: "updateQuestionTag",
              path: ":positionTagId/updateQuestionTag/:id",
              component: () => import("../components/tags/saveQuestionTag"),
            },
          ],
        },
        {
          name: "interviewQuestions",
          path: "interviewQuestions",
          component: EmptyParentComponent,
          children: [
            {
              name: "listInterviewQuestion",
              path: "listInterviewQuestion",
              component: () =>
                import(
                  "../components/interviewQuestions/listInterviewQuestion"
                ),
            },
            {
              name: "saveInterviewQuestion",
              path: "saveInterviewQuestion",
              component: () =>
                import(
                  "../components/interviewQuestions/saveInterviewQuestion"
                ),
            },
            {
              name: "updateInterviewQuestion",
              path: "updateInterviewQuestion/:id",
              component: () =>
                import(
                  "../components/interviewQuestions/saveInterviewQuestion"
                ),
            },
            {
              name: "listOrganization",
              path: "listOrganization",
              component: () =>
                import("../components/interviewQuestions/listOrganization"),
            },
            {
              name: "saveOrganization",
              path: "saveOrganization",
              component: () =>
                import("../components/interviewQuestions/saveOrganization"),
            },
            {
              name: "updateOrganization",
              path: "updateOrganization/:id",
              component: () =>
                import("../components/interviewQuestions/saveOrganization"),
            },
          ],
        },
        {
          name: "liuxue",
          path: "liuxue",
          component: EmptyParentComponent,
          children: [
            {
              name: "listRecentNews",
              path: "listRecentNews",
              component: () =>
                import("../components/liuxue/recentNews/listRecentNews"),
            },
            {
              name: "saveRecentNews",
              path: "saveRecentNews",
              component: () =>
                import("../components/liuxue/recentNews/saveRecentNews"),
            },
            {
              name: "updateRecentNews",
              path: "updateRecentNews/:id",
              component: () =>
                import("../components/liuxue/recentNews/saveRecentNews"),
            },
            {
              name: "listMentor",
              path: "listMentor",
              component: () => import("../components/liuxue/mentor/listMentor"),
            },
            {
              name: "saveMentor",
              path: "saveMentor",
              component: () => import("../components/liuxue/mentor/saveMentor"),
            },
            {
              name: "updateMentor",
              path: "updateMentor/:id",
              component: () => import("../components/liuxue/mentor/saveMentor"),
            },
            {
              name: "listSuccessCase",
              path: "listSuccessCase",
              component: () =>
                import("../components/liuxue/successCase/listSuccessCase"),
            },
            {
              name: "saveSuccessCase",
              path: "saveSuccessCase",
              component: () =>
                import("../components/liuxue/successCase/saveSuccessCase"),
            },
            {
              name: "updateSuccessCase",
              path: "updateSuccessCase/:id",
              component: () =>
                import("../components/liuxue/successCase/saveSuccessCase"),
            },
            {
              name: "listStudentStory",
              path: "listStudentStory",
              component: () =>
                import("../components/liuxue/studentStory/listStudentStory"),
            },
            {
              name: "saveStudentStory",
              path: "saveStudentStory",
              component: () =>
                import("../components/liuxue/studentStory/saveStudentStory"),
            },
            {
              name: "updateStudentStory",
              path: "updateStudentStory/:id",
              component: () =>
                import("../components/liuxue/studentStory/saveStudentStory"),
            },
            {
              name: "listPost",
              path: "listPost",
              component: () => import("../components/liuxue/post/listPost"),
            },
            {
              name: "savePost",
              path: "savePost/:postId",
              component: () => import("../components/liuxue/post/savePost"),
            },
          ],
        },
      ],
    },
  ],
});
